module.exports = __webpack_public_path__ + "img/1440.2bed6c53.jpg";